import { Settings } from 'luxon';

import { DEFAULT_LOCALE } from '../shared/i18n/i18n.config';

Settings.defaultLocale = DEFAULT_LOCALE;
Settings.defaultZone = 'Europe/Paris';

export function setDefaultLocale(locale: string): void {
    Settings.defaultLocale = locale;
}

export function setDefaultZone(zone: string): void {
    Settings.defaultZone = zone;
}
